import { FC } from 'external/react';
import useAdmin from 'context/admin-context/hook';
import CloseButton from './CloseButton';

const headerStyles: React.CSSProperties = {
  padding: '20px 24px 18px',
  borderBottom: '1px solid #f1f5f9',
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
};

const ChangeCourseModalHeader: FC = () => {

  const {updateChangeCourseModal} = useAdmin()

  const handleClose = () => updateChangeCourseModal(false, null, undefined, { subject: '', grade: '', course: '', source: '' }, null);

  return (
        <div style={headerStyles}>
          <div>
            <h5 style={{ margin: 0, fontWeight: 700, fontSize: 17, color: '#0f172a' }}>Cambiar Curso</h5>
            <p style={{ margin: '3px 0 0', fontSize: 12, color: '#94a3b8' }}>Selecciona materia, grado y curso</p>
          </div>
          <CloseButton onClick={handleClose} />
        </div>
  );
};

export default ChangeCourseModalHeader;